<template>
		<div class="d-flex flex-1 h-100">
			<v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
				<v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
					<div class="custom-icon-wrapper">
						<v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
					</div>
					<v-toolbar-title v-if="PageNum == 1" class="size-16 dark-text">{{
                    $t("res_Title_ManagePrivaces")
                    }}</v-toolbar-title>
					<v-toolbar-title v-if="PageNum == 2" class="size-16 dark-text">{{
                    $t("res_Title_ManageImportances")
                    }}</v-toolbar-title>
					<v-toolbar-title v-if="PageNum == 3" class="size-16 dark-text">{{
                    $t("res_Title_ManagePriorities")
                    }}</v-toolbar-title>
					<v-toolbar-title v-if="PageNum == 4" class="size-16 dark-text">{{
                    $t("res_Title_ManagePurposes")
                    }}</v-toolbar-title>
				</v-toolbar>
				<div class="border-top align-items-center gap-3">
					<v-dialog v-model="openAddEditDialog" max-width="700" style="height: 500px;">
						<v-card style="height: 500px;">
							<v-toolbar class="bg-white">
								<v-card-title class="p-0"></v-card-title>
								<v-spacer></v-spacer>
								<v-btn class="close-btn light-btn" icon dark @click="openAddEditDialog = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<div class="d-flex flex-column overflow-auto h-100">
								<div class="grid-12 flex-1 p-4 overflow-auto gap-2">
									<v-row>
										<v-col cols="12" sm="6">
											<v-label> NameEn*</v-label>
											<v-text-field v-model="documentLookups.name" solo></v-text-field>
										</v-col>
										<v-col cols="12" sm="6">
											<v-label> NameAr*</v-label>
											<v-text-field v-model="documentLookups.nameAr" solo></v-text-field>
										</v-col>

									</v-row>
									<v-row>
										<v-col cols="12" sm="6" v-if="PageNum==1">
											<v-label> Level</v-label>
											<v-text-field v-model="documentLookups.level" type="Number" solo></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" v-if="PageNum==3">
											<v-label> Color*</v-label>
											<v-text-field v-model="documentLookups.Color" solo></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" v-if="PageNum==2">
											<v-label> Icon Color</v-label>
											<v-text-field v-model="documentLookups.IconColor" solo></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" v-if="PageNum==3">
											<v-label> Number Of Due Days</v-label>
											<v-text-field v-model="documentLookups.NumberOfDueDays" type="Number" solo></v-text-field>
										</v-col>
										<v-col v-if="PageNum == 4" cols="12" sm="6">
											<v-label> Cced</v-label>
											<v-checkbox v-model="documentLookups.cced" solo></v-checkbox>
										</v-col>
										<v-col v-if="PageNum == 4" cols="12" sm="6">
											<v-label> ShowInWorkflow</v-label>
											<v-checkbox v-model="documentLookups.ShowInWorkflow" solo></v-checkbox>
										</v-col>
									</v-row>
								</div>
							</div>
							<v-card-actions class="gap-2 sticky-actions">
								<v-spacer></v-spacer>
								<v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelAddDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
								<v-btn class="primary" style="min-width: 100px !important;" @click="upsertItem()">{{ $t("res_ButtonText_Continue") }}</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>
				<div class="p-2 text-end">
					<v-btn @click="OpenAddEditDialog()" width="100px" color="primary" style="margin-right: 10px;">Add</v-btn>
				</div>
				<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px" v-if="PageNum==1">
					<v-data-table :headers="headers" :items="privacies" :items-per-page="privacies.length" :mobile-breakpoint="0" disable-sort
					 :loading="loading" loading-text="loading..." caption="" calculate-widths header-fixed
					  fixed-header hide-default-footer class="position-relative white flex-1 d-flex overflow-auto">
						<template v-slot:item="row">
							<tr>
								<td>{{ row.item.name }}</td>
								<td>{{ row.item.nameAr }}</td>
								<td>{{ row.item.level }}</td>
								<td class="text-start">
									<div class="onhover-display">
										<div class="custom-icon-wrapper">
											<v-icon @click="EditData(row.item)">custom-icon white-bg edit-icon</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon @click="Delete(row.item.id)">custom-icon white-bg delete-icon</v-icon>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
				<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px" v-if="PageNum==2">
					<v-data-table :headers="headers2" :items="imporatanceses" :items-per-page="imporatanceses.length"
					 :mobile-breakpoint="0" disable-sort :loading="loading" loading-text="loading..." caption="" calculate-widths header-fixed
					  fixed-header hide-default-footer class="position-relative white flex-1 d-flex overflow-auto">
						<template v-slot:item="row">
							<tr>
								<td>{{ row.item.name }}</td>
								<td>{{ row.item.nameAr }}</td>
								<td class="text-start">
									<div class="onhover-display">
										<div class="custom-icon-wrapper">
											<v-icon @click="EditData(row.item)">custom-icon white-bg edit-icon</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon @click="Delete(row.item.id)">custom-icon white-bg delete-icon</v-icon>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
				<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px" v-if="PageNum==3">
					<v-data-table :headers="headers3" :items="priorities" :items-per-page="priorities.length"
					 :mobile-breakpoint="0" disable-sort :loading="loading" loading-text="loading..." caption="" calculate-widths header-fixed
					  fixed-header hide-default-footer class="position-relative white flex-1 d-flex overflow-auto">
						<template v-slot:item="row">
							<tr>
								<td>{{ row.item.name }}</td>
								<td>{{ row.item.nameAr }}</td>
								<td>{{ row.item.numberOfDueDays }}</td>
								<td class="text-start">
									<div class="onhover-display">
										<div class="custom-icon-wrapper">
											<v-icon @click="EditData(row.item)">custom-icon white-bg edit-icon</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon @click="Delete(row.item.id)">custom-icon white-bg delete-icon</v-icon>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
				<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px" v-if="PageNum==4">
					<v-data-table :headers="headers4" :items="purposes" :items-per-page="purposes.length"
					 :mobile-breakpoint="0" disable-sort :loading="loading" loading-text="loading..." caption="" calculate-widths header-fixed 
					 fixed-header hide-default-footer class="position-relative white flex-1 d-flex overflow-auto">
						<template v-slot:item="row">
							<tr>
								<td>{{ row.item.name }}</td>
								<td>{{ row.item.nameAr }}</td>
								<td class="text-start">
									<div class="onhover-display">
										<div class="custom-icon-wrapper">
											<v-icon @click="EditData(row.item)">custom-icon white-bg edit-icon</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon @click="Delete(row.item.id)">custom-icon white-bg delete-icon</v-icon>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</v-card>
		</div>
</template>
<script>
import router from "@/router/index.js";
import axios from "axios";
import constants from "@/assets/js/constants";
import ManageSystemLookups from "../admin/ManageSystemLookups.vue";
export default {
	name: "managedocumentlookups",
	components: { ManageSystemLookups },
	data() {
		return {
			headers: [
				{ text: "Name", value: "name", align: "start", width: "30%" },
				{ text: "NameAr", value: "namear", align: "start", width: "30%" },
				{ text: "Level", value: "level", align: "start", width: "30%" },
				{ text: "Actions", value: "actions", align: "start", width: "10%" },
			],
			headers2: [
				{ text: "Name", value: "name", align: "start", width: "45%" },
				{ text: "NameAr", value: "namear", align: "start", width: "45%" },
				{ text: "Actions", value: "actions", align: "start", width: "10%" },
			],
			headers3: [
				{ text: "Name", value: "name", align: "start", width: "30%" },
				{ text: "NameAr", value: "namear", align: "start", width: "30%" },
				{ text: "Number Of Due Days", value: "numberOfDueDays", align: "start", width: "30%" },
				{ text: "Actions", value: "actions", align: "start", width: "10%" },
			],
			headers4: [
				{ text: "Name", value: "name", align: "start", width: "45%" },
				{ text: "NameAr", value: "namear", align: "start", width: "45%" },
				{ text: "Actions", value: "actions", align: "start", width: "10%" },
			],
			privacies: [],
			imporatanceses: [],
			priorities: [],
			purposes: [],
			openAddEditDialog: false,
			documentLookups: {
				name: "",
				nameAr: "",
				level: 0,
				cced: false,
				NumberOfDueDays: null,
				Color: "",
				IconColor: "",
				ShowInWorkflow:false,
			},
			Id: 0,
			PageNum: null,
			isPriority:false,
		};
	},
	mounted() {
		if (this.PageNum == 1) {
			this.GetPrivacy();
		} else if (this.PageNum == 2) {
			this.GetImportance();
		} else if (this.PageNum == 3) {
			this.GetPriority();
		} else if (this.PageNum == 4) {
			this.GetPurpose();
		}
	},
	created() {
		this.PageNum = Number(this.$route.params.pagenum);
	},
	methods: {
		backToAdminPage() {
			router.push({ name: "manageSystemLookups" });
		},
		cancelAddDialog() {
			this.openAddEditDialog = false;
			this.documentLookups = {
				name: "",
				nameAr: "",
				level: 0,
				cced: false,
				NumberOfDueDays: null,
				Color: "",
				IconColor: "",
				ShowInWorkflow:false,
			};
		},
		OpenAddEditDialog(){
			this.openAddEditDialog =true;
			if(this.PageNum == 3){
				this.isPriority = true;
			}
		},
		upsertItem() {
			if(this.documentLookups.name == "" || this.documentLookups.nameAr =="" ||(this.documentLookups.Color=="" && this.isPriority==true)){
				window.showAlert('res_Msgs_FillRequired', 'warning')
				return
			}
			this.openAddEditDialog = false;
			if (this.Id == 0) {
				this.Add();	
			} else {
				this.openAddEditDialog = false;
				this.Edit();		
			}
			this.documentLookups = {
				name: "",
				nameAr: "",
				level: 0,
				cced: false,
				NumberOfDueDays: null,
				Color: "",
				IconColor: "",
				ShowInWorkflow:false,
			};
		},
		Add() {
			if (this.PageNum == 1) {
				this.AddPrivacy();
			} else if (this.PageNum == 2) {
				this.AddImportance();
			} else if (this.PageNum == 3) {
				this.AddPriority();
			} else if (this.PageNum == 4) {
				this.AddPurpose();
			}
		},
		Edit() {
			if (this.PageNum == 1) {
				this.UpdatePrivacy();
			} else if (this.PageNum == 2) {
				this.UpdateImportance();
			} else if (this.PageNum == 3) {
				this.UpdatePriority();
			} else if (this.PageNum == 4) {
				this.UpdatePurpose();
			}
		},
		EditData(item) {
			if(this.PageNum == 3){
				this.isPriority = true;
			}
			this.openAddEditDialog = true;
			this.Id = item.id;
			this.documentLookups = {
				name: item.name,
				nameAr: item.nameAr,
				level: item.level,
				cced: item.cced,
				NumberOfDueDays: item.numberOfDueDays,
				Color: item.color,
				IconColor: item.iconColor,
				ShowInWorkflow:item.showInWorkflow,
			};
		},
		Delete(id) {
			this.Id = id;
			if (this.PageNum == 1) {
				this.DeletePrivacy();
			} else if (this.PageNum == 2) {
				this.DeleteImportance();
			} else if (this.PageNum == 3) {
				this.DeletePriority();
			} else if (this.PageNum == 4) {
				this.DeletePurpose();
			}
		},
		async GetPrivacy() {
			await axios
				.get(`${constants.baseApiUrl}Admin/GetPrivacy`)
				.then((res) => {
					this.privacies = res.data;
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async AddPrivacy() {
			await axios
				.post(`${constants.baseApiUrl}Admin/Addprivacy`, this.documentLookups)
				.then(() => {
					this.GetPrivacy();
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async UpdatePrivacy() {
			await axios
				.post(
					`${constants.baseApiUrl}Admin/UpdatePrivacy?Id=${this.Id}`,
					this.documentLookups
				)
				.then(() => {
					this.GetPrivacy();
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async DeletePrivacy() {
			window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
				() => {
					axios
						.get(`${constants.baseApiUrl}Admin/DeletePrivacy?Id=${this.Id}`)
						.then(() => {
							this.GetPrivacy();
						})
						.catch((error) => {
							console.log({ error });
						});
				}
			);
		},
		async GetImportance() {
			await axios
				.get(`${constants.baseApiUrl}Admin/GetImportance`)
				.then((res) => {
					this.imporatanceses = res.data;
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async AddImportance() {
			await axios
				.post(
					`${constants.baseApiUrl}Admin/AddImportance`,
					this.documentLookups
				)
				.then(() => {
					this.GetImportance();
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async UpdateImportance() {
			await axios
				.post(
					`${constants.baseApiUrl}Admin/UpdateImportance?Id=${this.Id}`,
					this.documentLookups
				)
				.then(() => {
					this.GetImportance();
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async DeleteImportance() {
			window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
				() => {
					axios
						.get(`${constants.baseApiUrl}Admin/DeleteImportance?Id=${this.Id}`)
						.then(() => {
							this.GetImportance();
						})
						.catch((error) => {
							console.log({ error });
						});
				}
			);
		},
		async GetPriority() {
			await axios
				.get(`${constants.baseApiUrl}Admin/GetPriority`)
				.then((res) => {
					this.priorities = res.data;
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async AddPriority() {
			await axios
				.post(`${constants.baseApiUrl}Admin/AddPriority`, this.documentLookups)
				.then(() => {
					this.GetPriority();
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async UpdatePriority() {
			await axios
				.post(
					`${constants.baseApiUrl}Admin/UpdatePriority?Id=${this.Id}`,
					this.documentLookups
				)
				.then(() => {
					this.GetPriority();
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async DeletePriority() {
			window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
				() => {
					axios
						.get(`${constants.baseApiUrl}Admin/DeletePriority?Id=${this.Id}`)
						.then(() => {
							this.GetPriority();
						})
						.catch((error) => {
							console.log({ error });
						});
				}
			);
		},
		async GetPurpose() {
			
			await axios
				.get(`${constants.baseApiUrl}Admin/GetPurpose`)
				.then((res) => {
					this.purposes = res.data;
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async AddPurpose() {
			await axios
				.post(`${constants.baseApiUrl}Admin/AddPurpose`, this.documentLookups)
				.then(() => {
					this.GetPurpose();
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		async UpdatePurpose() {
		try {
			await axios.post(
            `${constants.baseApiUrl}Admin/UpdatePurpose?Id=${encodeURIComponent(this.Id)}`,
            this.documentLookups,
            { headers: { 'Content-Type': 'application/json' } }
       		);
			this.GetPurpose();
			} catch (error) {
				console.error('Error updating purpose:', error.response ? error.response.data : error.message);
			}
		},
		async DeletePurpose() {
			window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
				() => {
					axios
						.get(`${constants.baseApiUrl}Admin/DeletePurpose?Id=${this.Id}`)
						.then(() => {
							this.GetPurpose();
						})
						.catch((error) => {
							console.log({ error });
						});
				}
			);
		},
	},
};
</script>